<rask-toggle-panel class="list" size="4" label="Sök direkt i kartan" [defaultExpanded]="panelMapExpanded"
  (onToggle)="onToggleMapSearch($event)">
  @if (isClickActivated()) {
    <div class="container">
      <rask-validation-message-row
        type="info"
      message="Klicka på en fastighet i kartan för att hämta uppgifter."></rask-validation-message-row>
    </div>
  }
  <div class="container">
    @if (!isClickActivated()) {
      <rask-button color="primary" (click)="activateClickInMap()">Välj fastighet</rask-button>
    }
    @if (!isNothingSelected() && isClickActivated()) {
      <rask-button color="secondary" negative class="neutral" negative (click)="clickCancel()">Avbryt
      </rask-button>
    }
  </div>
</rask-toggle-panel>
<rask-toggle-panel class="list" size="4" label="Sök via formulär" [defaultExpanded]="panelFormExpanded"
  (onToggle)="onToggleFormSearch($event)">
  <div class="container">
    <rask-selector
      label="KOMMUN"
      [search]="kommunSearch"
      [viewFormatter]="kommunViewFormatter"
      [formatter]="kommunFormatter"
      [minCharacters]="3"
      [(ngModel)]="kommun"
      [debounceTime]="200">
    </rask-selector>
    <rask-input label="FASTIGHETSBETECKNING" [(ngModel)]="fastighetsbeteckning"></rask-input>
  </div>
  <div class="container">
    <rask-button color="primary" [disabled]="formSearchDisabled()" (click)="searchKommunBeteckning()">Sök</rask-button>
    @if (!isNothingSelected()) {
      <rask-button color="secondary" negative (click)="clickCancel()">Avbryt</rask-button>
    }
  </div>
</rask-toggle-panel>
@if (hasFastigheterHistory()) {
  <rask-toggle-panel class="list" size="4" label="Hämtade Fastigheter ({{fastigheterHistory?.length}})" [defaultExpanded]="false">
    <div class="container">
      @for (fastighet of fastigheterHistory; track fastighet) {
        <div class="fastighetoption">
          <a href="javascript: void(0)" (click)="clickFastighetHistory(fastighet)">
            {{ fastighet?.fastighet?.fastighetsbeteckning }}
          </a>
        </div>
      }
    </div>
  </rask-toggle-panel>
}

